module.exports = __webpack_public_path__ + "static/img/dianbj.019f1093.png";